<template>
    <modal-controller-base contentClass="light-light-background purple-purple-color news-safe-area-bottom">
        <template #header>
            <custom-header back-button :title="$t(`titleRoute.${productSuggestion ? 'suggestion' : 'news'}`)">
                <template #start>
                    <ion-button @click="modalController.dismiss()" class="purple-light-color">
                        <ion-icon :icon="chevronBack" />
                        {{ $t('button.back') }}
                    </ion-button>
                </template>
            </custom-header>
        </template>

        <button-navigations
            v-if="!isApp() && productSuggestion && !noButtons"
            :is-button-back="isButtonBack"
            :is-button-forward="isButtonForward"
            @foward="goFoward"
            @back="goBack"
        />

        <information-interface
            :information="currentInformation"
            :item-placeholder="productSuggestion"
            @add="addToList"
        />
    </modal-controller-base>
</template>

<script setup lang="ts">
import { IonButton, IonIcon, modalController } from "@ionic/vue";
import { computed, ref } from "vue";
import { chevronBack } from "ionicons/icons";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import InformationInterface from "@/components/modal/InformationInterface.vue";
import ButtonNavigations from "@/components/button/ButtonNavigations.vue";

import { useNotificationStore } from "@/stores/notification";

import { isApp } from "@/functions/enviroment";

import { useInformationModal } from "@/composables/viewFunctions/useInformationModal";

import { NewsDisplayProps } from "@/types/props";
import { Information } from "@/types/notification";
import { ProductMaster } from "@/types/supplier";

const props = defineProps<NewsDisplayProps>()

const { addInformationProductToList } = useInformationModal(props.information)
const notificationStore = useNotificationStore()

const currentInformation = ref<Information>(props.information)

const isButtonBack = computed<boolean>(() => notificationStore.currentInformationIndex > 0)
const isButtonForward = computed<boolean>(() => notificationStore.currentInformationIndex < notificationStore.productSuggestion.data.length - 1)

const addToList = async (params: { product: ProductMaster, amount: number }): Promise<void> => {
    if (!params.product) return
    await addInformationProductToList(params.product, params.amount, props.noAutoSelect, currentInformation.value.id)
}

const goBack = (): void => {
    if (isButtonBack.value && props.productSuggestion) {
        notificationStore.currentInformationIndex -= 1
        currentInformation.value = notificationStore.findProductSuggestion()
    }
}

const goFoward = (): void => {
    if (isButtonForward.value && props.productSuggestion) {
        notificationStore.currentInformationIndex += 1
        currentInformation.value = notificationStore.findProductSuggestion()
    }
}
</script>

<style>
html.ios .news-safe-area-bottom::part(scroll) {
    --offset-bottom: -1rem;
}
</style>
